import config from "config/config";

export const loadConfig = (): any => {
  const env = process.env.SERVER_ENV || "local";
  return config[env];
};
